import { h, Component } from 'preact';
import { Text } from 'preact-i18n';
import IconListItem from '../icon-list-item';
import LocationsList from '../locations-list';
import style from './style.less';
import cx from 'classnames';

export default class RecentLocations extends Component { // eslint-disable-line react/prefer-stateless-function
	render({ locations = [], maxFavorites, onAddFavorite, onSetCurrent, isFavoritesFull, ...props }) {
		return (
			<LocationsList {...props} header={<Text id="recentlySearched" />}>
				{locations.map((location, index) => (
					<IconListItem
						location={location}
						class={cx(style.focusStar, isFavoritesFull && style.disabled)}
						icon="star-cube"
						onClickLocation={onSetCurrent}
						onClickIcon={onAddFavorite}
					/>
				))}
			</LocationsList>
		);
	}
}
